import React, { useCallback, useState } from "react";
import { MdLink } from "react-icons/md";
import { useIntl } from "react-intl";
import { linkCarToOperation } from "~/api";
import { useOperation } from "~/hooks/useOperation";

const CAR_SIZE = 43;

const DownloadCar = ({ reload, setError }) => {
  const { operation } = useOperation();
  const { formatMessage } = useIntl();

  const [isLoading, setIsLoading] = useState(false);
  const [numeroCar, setNumeroCar] = useState("");

  const handleSearchChange = useCallback(e => {
    setNumeroCar(e.target.value);
  }, []);

  const downloadAndLinkCar = useCallback(async () => {
    try {
      const replaced = numeroCar?.replaceAll('.', '');

      if (replaced.length !== CAR_SIZE) {
        setError('Formato do CAR incorreto');
        return;
      }

      setIsLoading(true);

      await linkCarToOperation({
        b3_proposta_id: operation.id,
        numero_car: replaced
      });

      setNumeroCar('');
      setIsLoading(false);
    } catch (e) {
      setError(formatMessage({ id: "erro-api" }));
      setIsLoading(false);
      return;
    }
    reload();
  }, [numeroCar, operation.id, reload, formatMessage, setError]);

  return (
    <div className="selected-car-no-border">
      <div/>
      <input
        disabled={isLoading}
        className="input"
        value={numeroCar}
        type="text"
        name="car-name"
        id="car-name"
        placeholder="Insira o recibo do CAR"
        onChange={handleSearchChange}
      />
      <div className="text-label">
        {formatMessage({ id: "formato-car-recibo" })}
      </div>
      <div className="text-label">
        {formatMessage({ id: "formato-car-recibo2" })}
      </div>
      <div className="link-car-button-wrapper">
        <button disabled={isLoading} className="link-car-button" onClick={downloadAndLinkCar}>
          <MdLink size={20} /> {formatMessage({ id: "vincular" })}
        </button>
      </div>
    </div>
  );
};

export default DownloadCar;
